import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { EXCHANGE_API } from 'src/app/shared/app-token';
import { ExchangeRateDataset } from '../types/exchange-rates';
import { SharedService } from './shared.service';

/**
 * Exchange rates service
 * @class ExchangeService
 * @typedef {ExchangeService}
 */

@Injectable( {
    providedIn: 'root'
} )
export class ExchangeService {
    #apiUrl = inject( EXCHANGE_API );
    #httpClient = inject( HttpClient );
    #sharedService = inject( SharedService );

    // This method retrieves a list of publishers from the API
    getPublishers(): Observable<any[]> {
        let headers = new HttpHeaders();

        return this.#httpClient.get<any[]>( `${this.#apiUrl}/publishers`, { headers } );
    }

    // This method retrieves the latest exchange rates for a specific publisher, identified by publisherId.
    getExchangeRates( publisherId: string ): Observable<ExchangeRateDataset[]> {
        let headers = new HttpHeaders();

        return this.#httpClient
            .get<ExchangeRateDataset[]>( `${this.#apiUrl}/rates/${publisherId}/latest/`, { headers } );
    }
}
